import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf0fc55c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }
const _hoisted_2 = { class: "is-flex is-align-items-center is-justify-content-space-between mb-10" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "app-version"
}

import { useRouter } from 'vue-router'

import Profile from '@/popup/components/views/Home/Settings/Profile/Profile.vue'
import Network from '@/popup/components/views/Home/Settings/Network/Network.vue'
// import CameraAccess from '@/popup/components/views/Home/Settings/Security/CameraAccess.vue'
import Localization from '@/popup/components/views/Home/Settings/Localization/Localization.vue'
import Autolock from '@/popup/components/views/Home/Settings/Autolock/AutoLock.vue'
import ChangePassword from '@/popup/components/views/Home/Settings/ChangePassword/ChangePassword.vue'
import { getVersionName } from '@/shared/popup'
import IconButton from '@/popup/components/shared/IconButton.vue'
import Develop from '@/popup/components/views/Home/Settings/Profile/Develop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const router = useRouter()
const appVersion = getVersionName()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('settings.header')), 1 /* TEXT */),
      _createVNode(IconButton, {
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/home')))
      })
    ]),
    _createCommentVNode(" Profile component is hidden awaiting the completion of the backup feature DEV-9071 "),
    _createVNode(Profile),
    _createVNode(ChangePassword),
    _createVNode(Network),
    _createCommentVNode(" Disable device-to-device import until we redesign the UX\n      <CameraAccess /> "),
    _createVNode(Autolock),
    _createVNode(Localization),
    _createVNode(Develop),
    (_unref(appVersion))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "v" + _toDisplayString(_unref(appVersion)), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})